<template>
  <q-page padding>
    <PageHeader :backRoute="{ name: 'home' }" backBehavior="route">
      <template #title>Listagem de Catálogos</template>
      <template #actions>
        <span class="q-ml-sm text-brand-5"
          >- veja todos os catálogos disponíveis</span
        >
      </template>
    </PageHeader>
    <div>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        :columns="columns"
        v-model:pagination="pagination"
        class="q-mt-md tabela-tamanho-fixo"
        row-key="name"
        dense
        hide-pagination
        @request="handleRequest"
      >
        <template #body-cell-criado="props">
          <q-td>
            <div v-if="props.row.contract && props.row.contract.created_at">
              {{
                props.row.contract.created_at
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
            </div>
            <div
              v-if="props.row.contract && props.row.contract.created_at"
              class="q-pl-sm"
            >
              {{ props.row.contract.created_at.split(" ")[1] }}
            </div>
          </q-td>
        </template>
        <template #body-cell-adicionar="props">
          <q-td>
            <q-btn
              round
              color="positive"
              icon="add"
              @click="adicionar(props.row.contract.id)"
            />
          </q-td>
        </template>
        <template #body-cell-acompanhar="props">
          <q-td>
            <q-btn
              round
              color="primary"
              icon="visibility"
              @click="acompanhar(props.row.contract.id)"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "id",
    label: "ID",
    field: (row) => (row.contract && row.contract.id ? row.contract.id : ""),
    align: "left",
  },
  {
    name: "usuario_nome",
    label: "Código",
    field: (row) =>
      row.contract && row.contract.code ? row.contract.code : "",
    align: "left",
  },
  {
    name: "status",
    label: "Descrição",
    field: (row) =>
      row.contract && row.contract.description ? row.contract.description : "",
    align: "left",
  },
  {
    name: "criado",
    label: "Criado em",
    field: "criado",
    align: "left",
  },
  {
    name: "adicionar",
    label: "Adicionar",
    align: "left",
    field: "updated_at",
  },

  {
    name: "acompanhar",
    label: "Acompanhar",
    field: "acompanhar",
    align: "left",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { ref, onMounted, computed, watch } from "vue";
import { useRouter } from "vue-router";
import PageHeader from "../../../../components/PageHeader.vue";
export default {
  components: {
    PageHeader,
  },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const quasar = useQuasar();
    const router = useRouter();
    const disable = ref(true);
    const filtros = ref({
      dataInicial: "",
      dataFinal: new Date()
        .toLocaleString("pt-br")
        .split(" ")[0]
        .replace(",", " "),
      solicitante: "",
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async (page = 0, rowsPerPage = 15) => {
      console.log("oi");
      try {
        let response = await store.dispatch("wf/getListagem", {
          page,
          per_page: rowsPerPage,
        });
        rows.value = response.data.results.data;

        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.rowsNumber = response.data.results.total;

        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const adicionar = async (id) => {
      router.push({ name: "catalogo-wf-gestao", params: { id } });
    };

    const acompanhar = async (id) => {
      router.push({ name: "catalogo-wf-acompanhamento", params: { id } });
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    return {
      rows,
      columns,
      getDados,
      handleRequest,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      filtros,
      pagination,
      disable,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      adicionar,
      acompanhar,
    };
  },
};
</script>
